import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import DetergentsPageHeader from '@/components/pages/Detergents/List/PageHeader'
import DetergentsTable from '@/components/pages/Detergents/List/Table'
import routes from '@/constants/routes'
import { Detergent } from '@/types'

import { useDetergents } from './Detergent.hooks'

const Detergents = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { getDetergentsLoading, getDetergentsResponse, getDetergents, deleteDetergent, filterToQuery, page, pageSize } =
    useDetergents()

  const totalItems = getDetergentsResponse?.meta.totalItems || 0

  const handleDeleteMachinePart = async (id: Detergent['id']) => {
    await deleteDetergent({ id })
    getDetergents()
  }

  const handleChangePage = (config: TablePaginationConfig) => {
    navigate({
      pathname: routes.detergents.path,
      search: filterToQuery({
        page: config.current ?? page,
      }),
    })
  }

  useEffect(() => {
    getDetergents()
  }, [getDetergents, id])

  return (
    <>
      <DetergentsPageHeader />
      <DetergentsTable
        {...{
          dataSource: getDetergentsResponse?.items,
          getDetergentsLoading,
          page,
          pageSize,
          totalItems,
        }}
        onDelete={handleDeleteMachinePart}
        onChange={handleChangePage}
      />
    </>
  )
}

Detergents.displayName = 'Detergents'
export default Detergents
